/** Textes « schemaVoiture » — le français fait foi. */
export const schemaVoiture = {
  avant: 'AVANT',
  arriere: 'Arrière',
  constateDepart: (detail: string) => `Constaté au départ — ${detail}`,
  toucherCarrosserie: 'Touchez la carrosserie pour marquer un dommage',
  effacer: 'Effacer',
  signe: 'Signé',
};
